import { Link, Typography } from "@mui/material";
import { Fragment, type ReactNode } from "react";
import { Link as RouterLink } from "react-router";
import type { RichText } from "./frontpageContent";

export const ContentText = ({ content }: { content: RichText }) =>
  content.map((part, index) => {
    if (typeof part === "string")
      return <Fragment key={index}>{part}</Fragment>;
    let node: ReactNode = part.text;
    if (part.italic) node = <em>{node}</em>;
    if (part.bold) node = <strong>{node}</strong>;
    if (part.href === "/guide")
      node = (
        <Link component={RouterLink} to={part.href}>
          {node}
        </Link>
      );
    else if (part.href)
      node = (
        <Link
          href={part.href}
          {...(part.href.startsWith("http")
            ? { target: "_blank", rel: "noopener noreferrer" }
            : {})}
        >
          {node}
        </Link>
      );
    return <Fragment key={index}>{node}</Fragment>;
  });
export const ContentParagraphs = ({ paragraphs }: { paragraphs: RichText[] }) =>
  paragraphs.map((content, index) => (
    <Typography
      variant="inherit"
      component="p"
      sx={{ fontSize: "inherit", lineHeight: "inherit" }}
      key={index}
    >
      <ContentText content={content} />
    </Typography>
  ));
